import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class CompanyModel extends Model {
  static reducer(action, CompanyModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Company.schema:
        action.payload.forEach((payload) => {
          const dbData = CompanyModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          CompanyModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
CompanyModel.modelName = "CompanyModel";

CompanyModel.fields = {
  id: attr(),
};

export default CompanyModel;